import { lazy } from "react";
import { AlertTriangle } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

/**
 * Alerts — replaces the former `anomalies` and `leaks` features, which were two
 * nav entries over the same rows. Roles match the backend router guard, which is
 * the stricter of the two it replaces.
 */
export const alertsFeature: FeatureDescriptor = {
  id: "alerts",
  flag: "alerts",
  path: "/alerts",
  navKey: "nav.alerts",
  group: "operate",
  icon: AlertTriangle,
  element: lazy(() => import("./AlertsPage")),
  roles: ["admin", "manager"],
  scope: { locality: true, days: true },
};
